import * as i0 from "@angular/core";
/**
 * Check whether an item is selected
 *
 * value: A composite object of booleans organized by category, section, menu, and metric ids, marking which metrics
 *   have been selected.
 *
 * Params:
 *   metricId: A unique string identifying the metric, usually known as `internal_name`.
 *   categoryLabel: The label of the metric's category; this is the broadest way metrics are grouped.
 *   sectionLabel: The label of the metric's section; this is part of a category and can contain individual metrics or
 *     submenus of individual metrics.
 *   menuLabel: The label of the metric's menu, if the metric is part of a submenu. Not all metrics are part of submenus.
 *
 */
export class IsItemSelected {
    transform(value, metricId, categoryLabel, sectionLabel, menuLabel) {
        if (menuLabel) {
            return value[categoryLabel][sectionLabel][menuLabel][metricId];
        }
        return value[categoryLabel][sectionLabel][metricId];
    }
}
IsItemSelected.ɵfac = function IsItemSelected_Factory(t) { return new (t || IsItemSelected)(); };
IsItemSelected.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isItemSelected", type: IsItemSelected, pure: true });
